import { forwardRef } from "react";
import { tv } from "tailwind-variants";

import type { ComponentPropsWithoutRef } from "react";
import type { VariantProps } from "tailwind-variants";

const bannerVariants = tv({
  base: "line-height-8 flex h-8 flex-fixed items-center justify-center px-4 text-center",
  variants: {
    color: {
      default: "bg-gray-900 text-white",
      info: "bg-blue-500 text-white",
      success: "bg-green-500 text-white",
      warning: "bg-yellow-500 text-white",
      danger: "bg-red-500 text-white",
    },
  },
  defaultVariants: {
    color: "default",
  },
});

export type BannerProps = ComponentPropsWithoutRef<"header"> & VariantProps<typeof bannerVariants>;

export const Banner = forwardRef<HTMLElement, BannerProps>(
  ({ className, color, ...props }, ref) => {
    return <header ref={ref} className={bannerVariants({ color, className })} {...props} />;
  }
);
Banner.displayName = "Banner";
